import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { BreakingnewsSetupPage } from './-components/BreakingnewsSetupPage';

export const Route = createFileRoute('/_authenticated/breakingnews/new')({
    validateSearch: z.object({
        // Prefills the push message. The URL gives a number for a message such as `123`.
        message: z.coerce.string().optional().catch(undefined),
    }),
    component: BreakingnewsSetupPage,
});
